import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

const PAGE_TYPE = 'realestate-eldeco';

// Eldeco campaign's own GTM container (the site-wide GTM-PSPS8S7B loads from index.html)
const ELDECO_GTM_ID = 'GTM-MSMP54P4';

@Component({
  selector: 'app-realestate-eldeco',
  templateUrl: './realestate-eldeco.component.html',
  styleUrls: ['./realestate-eldeco.component.css']
})
export class RealestateEldecoComponent implements OnInit, OnDestroy {

  name: string = '';
  email: string = '';
  mobile: string = '';

  nameValidateMessage: string = '';
  emailValidateMessage: string = '';
  mobileValidateMessage: string = '';
  otpValidateMessage: string = '';

  isLeadFormVisible: boolean = true;
  isOtpFormVisible: boolean = false;
  isThanksVisible: boolean = false;
  isVerifying: boolean = false;

  intervalId: any;
  timeleft: number = 0;
  clickedResend: number = 0;
  resendBtnTimer = 3;
  isTimer: boolean = true;
  isResend: boolean = false;
  userOTP: string = '';
  displayMobile: string = '';
  otpVerifiedStatus: boolean = true;

  visitorId: any;
  leadId: string = '';

  private gtmScriptEl: HTMLScriptElement | null = null;
  private gtmNoscriptEl: HTMLElement | null = null;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly service: DataService,
    private readonly titleService: Title,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Real Estate Advisory | Talk to Bajaj Capital');
    this.deferGtmInjection();
    if (this.router.url.split(/[?#]/)[0] === '/realestate-eldeco/thankyou') {
      this.isThanksVisible = true;
      this.isLeadFormVisible = false;
      this.isOtpFormVisible = false;
      return;
    }
    sessionStorage.removeItem('visitorId');
    sessionStorage.removeItem('leadId');
    this.createVisitor();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    if (this.gtmScriptEl) {
      this.gtmScriptEl.remove();
    }
    if (this.gtmNoscriptEl) {
      this.gtmNoscriptEl.remove();
    }
  }

  createVisitor() {
    let jscd = window['jscd'];
    let obj = {
      "browsername": jscd?.browser,
      "browserversion": jscd?.browser + ' ' + jscd?.browserVersion,
      "operatingsystem": jscd?.os + " " + jscd?.osVersion,
      "device": jscd?.os,
      "sourceurl": window.location.href,
      "productid": '75',
      "visitortype": PAGE_TYPE,
      "utmsource": this.GetParameterValues("utm_source"),
      "utmmedium": this.GetParameterValues("utm_medium"),
      "leadsource": this.GetParameterValues("lead_source"),
      "utmcampaign": this.GetParameterValues("utm_campaign"),
    };
    this.service.createVisitor(obj).subscribe((data: any) => {
      this.visitorId = data["visitorId"];
      sessionStorage.setItem('visitorId', data["visitorId"]);
    }, err => {
      console.log(err);
    });
  }

  PostData(leadForm: NgForm) {
    if (!this.checkValidationMsg(leadForm)) {
      return;
    }
    this.displayMobile = `${this.mobile.substring(0, 2)}XXXXX${this.mobile.substring(7)}`;
    this.createLead();
    this.isLeadFormVisible = false;
    this.isOtpFormVisible = true;
    this.isTimer = true;
    this.startTimer();
  }

  createLead() {
    let obj = {
      "visitorid": this.visitorId || sessionStorage.getItem('visitorId'),
      "leadid": sessionStorage.getItem('leadId') || 0,
      "name": this.name,
      "mobile": this.mobile,
      "email": this.email,
      "utmsource": this.GetParameterValues("utm_source"),
      "utmmedium": this.GetParameterValues("utm_medium"),
      "leadsource": this.GetParameterValues("lead_source"),
      "utmcampaign": this.GetParameterValues("utm_campaign"),
    };
    this.service.createLead(obj).subscribe((data: any) => {
      sessionStorage.setItem('leadId', data['leadid']);
      this.leadId = data['leadid'];
      this.sendOtp();
    }, err => {
      console.log(err);
    });
  }

  sendOtp() {
    this.service.sendOtp({ leadid: this.leadId, mobile: this.mobile }).subscribe(() => { }, err => {
      console.log(err);
    });
  }

  SubmitOTP(otpForm: NgForm) {
    this.userOTP = (otpForm.value.otp || '').trim();
    if (!this.userOTP) {
      this.otpValidateMessage = 'required';
      return;
    }
    if (this.userOTP.length !== 6) {
      this.otpValidateMessage = 'lengthError';
      return;
    }
    this.VerifyOTP();
  }

  VerifyOTP() {
    this.isVerifying = true;
    this.service.verifyOtp({ leadid: this.leadId, otp: this.userOTP }).subscribe((data: any) => {
      this.isVerifying = false;
      if (data["success"]) {
        sessionStorage.removeItem('leadId');
        sessionStorage.setItem('formSubmitted', 'true');
        clearInterval(this.intervalId);
        this.campaignlead();
        this.pushGtmLeadEvent();
        this.leadId = '';
        this.isThanksVisible = true;
        this.isLeadFormVisible = false;
        this.isOtpFormVisible = false;
        this.router.navigateByUrl('/realestate-eldeco/thankyou');
      } else {
        sessionStorage.setItem('formSubmitted', 'false');
        this.otpVerifiedStatus = false;
      }
    }, err => {
      this.isVerifying = false;
      console.log(err);
    });
  }

  campaignlead() {
    let obj = {
      name: this.name,
      mobile: this.mobile,
      email: this.email,
      pagetype: PAGE_TYPE,
      visitorid: this.visitorId,
      utmsource: this.GetParameterValues("utm_source"),
      utmmedium: this.GetParameterValues("utm_medium"),
      leadsource: this.GetParameterValues("lead_source"),
      utmcampaign: this.GetParameterValues("utm_campaign"),
    };
    this.service.campaignlead(obj).subscribe(() => { }, error => {
      console.error('Error in campaignlead:', error);
    });
  }


  // Pushed to the shared dataLayer, so both the site-wide and Eldeco GTM
  // containers can fire conversion tags on a verified lead
  pushGtmLeadEvent() {
    const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
    dataLayer.push({
      event: 'eldeco_lead_submit',
      page_type: PAGE_TYPE,
      utm_source: this.GetParameterValues('utm_source'),
      utm_medium: this.GetParameterValues('utm_medium'),
      utm_campaign: this.GetParameterValues('utm_campaign'),
    });
  }

  startTimer() {
    clearInterval(this.intervalId);
    this.otpVerifiedStatus = true;
    this.timeleft = 19;
    this.intervalId = setInterval(() => {
      if (this.timeleft == 0 && this.isOtpFormVisible) {
        this.isTimer = false;
        this.isResend = this.clickedResend < this.resendBtnTimer;
        clearInterval(this.intervalId);
      }
      this.timeleft -= 1;
    }, 1000);
  }

  resendOTP() {
    this.userOTP = '';
    this.clickedResend++;
    this.sendOtp();
    this.startTimer();
    this.isTimer = true;
    this.isResend = false;
  }

  changeNumber() {
    clearInterval(this.intervalId);
    this.userOTP = '';
    this.clickedResend = 0;
    this.isResend = false;
    this.isTimer = false;
    this.isLeadFormVisible = true;
    this.isOtpFormVisible = false;
    this.mobile = '';
  }

  removeErrorMsg(fieldname: string) {
    if (fieldname == 'otp') {
      this.otpValidateMessage = '';
      this.otpVerifiedStatus = true;
    }
    if (fieldname == 'name') {
      this.nameValidateMessage = '';
    }
    if (fieldname == 'email') {
      this.emailValidateMessage = '';
    }
    if (fieldname == 'mobile') {
      this.mobileValidateMessage = '';
    }
  }

  checkValidationMsg(leadForm: NgForm) {
    let num: number = 0;
    this.name = (leadForm.value.name || '').trim();
    this.email = (leadForm.value.email || '').trim();
    this.mobile = (leadForm.value.mobile || '').trim();

    if (!this.name) {
      this.nameValidateMessage = 'required';
      num += 1;
    } else if (this.name.length < 3) {
      this.nameValidateMessage = 'lengthError';
      num += 1;
    }

    if (!this.mobile) {
      this.mobileValidateMessage = 'required';
      num += 1;
    } else if (this.mobile.length != 10) {
      this.mobileValidateMessage = 'lengthError';
      num += 1;
    } else if (this.isMobileWrong(this.mobile) == 0) {
      this.mobileValidateMessage = 'invalid';
      num += 1;
    }

    if (!this.email) {
      this.emailValidateMessage = 'required';
      num += 1;
    } else if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(this.email)) {
      this.emailValidateMessage = 'invalid';
      num += 1;
    }

    return num === 0;
  }

  isMobileWrong(mobile: string) {
    if (!/^[6-9]/.test(mobile) || /^(\d)\1+$/.test(mobile)) {
      return 0;
    }
    return 1;
  }

  alphaOnly(event: any) {
    let key = event.keyCode;
    return ((key >= 65 && key <= 90) || key == 8 || key == 9 || key == 32 || (key >= 37 && key <= 40));
  }

  numbersOnly($event: any) {
    if ($event.target.value.length === 0 && /^[0-5]$/.test($event.key)) {
      return false;
    }
    return /^[0-9]+$/.test($event.key);
  }

  numbersOnlyotp($event: any) {
    return /^[0-9]$/.test($event.key);
  }

  private deferGtmInjection(): void {
    // Inject GTM during browser idle time, like talk-to-bcl
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(() => {
        this.injectGtmContainer();
      }, { timeout: 2000 });
    } else {
      // Fallback for Safari
      setTimeout(() => {
        this.injectGtmContainer();
      }, 1500);
    }
  }

  private injectGtmContainer(): void {
    // The form and thank-you routes both create this component; GTM keeps
    // running after its tags are removed, so don't load the container twice
    if ((window as any).google_tag_manager?.[ELDECO_GTM_ID]) {
      return;
    }

    this.gtmScriptEl = this.document.createElement('script');
    this.gtmScriptEl.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${ELDECO_GTM_ID}');
    `;
    this.document.head.appendChild(this.gtmScriptEl);

    this.gtmNoscriptEl = this.document.createElement('noscript');
    const iframe = this.document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${ELDECO_GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    this.gtmNoscriptEl.appendChild(iframe);
    if (this.document.body.firstChild) {
      this.document.body.insertBefore(this.gtmNoscriptEl, this.document.body.firstChild);
    } else {
      this.document.body.appendChild(this.gtmNoscriptEl);
    }
  }

  GetParameterValues(param: string) {
    return new URLSearchParams(window.location.search).get(param) || '';
  }
}
